<template>
  <v-container>
    <v-row no-gutters color="transparent" elevation="0">
      <v-col class="left-column">
        <TextArea
          :textTitle="endPointName"
          :textLinesArray="endpointDesc"
        ></TextArea>
        <TextArea
          :textTitle="filteringTitle"
          :textLinesArray="filteringText"
        ></TextArea>
      </v-col>
      <v-col class="right-column">
        <div style="padding-top: 20px">
          <EndpointCard cardTitle="ENDPOINTS" :endpoints="endpoints" />
        </div>
      </v-col>
    </v-row>
    <v-row no-gutters color="transparent" elevation="0">
      <v-col class="left-column">
        <Attribute :attributes="attributes" :endpoint="responseTitle" />
      </v-col>
      <v-col class="right-column">
        <div style="padding-top: 20px">
          <ResponseCard :response="response" :cardTitle="responseCodeTitle" />
        </div>
      </v-col>
    </v-row>
    <v-row no-gutters color="transparent" elevation="0">
      <v-col class="left-column">
        <Attribute :attributes="fileAttributes" :endpoint="fileResponseTitle" />
      </v-col>
      <v-col class="right-column">
        <div style="padding-top: 20px">
          <ResponseCard :response="fileResponse" :cardTitle="fileResponseCodeTitle" />
        </div>
      </v-col>
    </v-row>
    <v-row no-gutters color="transparent" elevation="0">
      <v-col class="left-column">
        <TextArea
          :textTitle="createInvoiceTitle"
          :textLinesArray="createInvoiceDesc"
        ></TextArea>
        <Attribute :attributes="createInvoiceRequestAttributes" :endpoint="createInvoiceRequestTitle" />
      </v-col>
      <v-col class="right-column">
        <div style="padding-top: 20px">
          <ResponseCard :response="createInvoiceRequest" :cardTitle="createInvoiceRequestCodeTitle" />
        </div>
      </v-col>
    </v-row>
    <v-row no-gutters color="transparent" elevation="0">
      <v-col class="left-column">
        <Attribute :attributes="createInvoiceAttributes" :endpoint="createInvoiceResponseTitle" />
      </v-col>
      <v-col class="right-column">
        <div style="padding-top: 20px">
          <ResponseCard :response="createInvoiceResponse" :cardTitle="createInvoiceResponseCodeTitle" />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import EndpointCard from "../../components/content/EndpointCard.vue";
import Attribute from "../../components/request/Attribute.vue";
import TextArea from "../../components/content/TextArea.vue";
import ResponseCard from "../../components/request/ResponseCard.vue";

const endPointName = "Invoices";
const ekURL = "/Invoice/AllInvoices";

export default {
  components: {
    EndpointCard,
    Attribute,
    TextArea,
    ResponseCard,
  },
  data() {
    return {
      filteringTitle: "Filtrering",
      filteringText: [
        "På dette endpoint kan man påføre filtrering med parametrene, <code>fromDate</code> og <code>toDate</code>. Hvis der ikke er påført filter vil der påføres et default filter, hvor <code>fromDate</code> er datoen 2000/01/01 og <code>toDate</code> er datoen 2030/01/01.",
      ],
      responseTitle: `The ${endPointName} Object`,
      responseCodeTitle: `${endPointName.toUpperCase()} RESPONSE. E-KOMPLET URL: ${ekURL}`,
      endPointName: endPointName,
      endpointDesc: [
        "Invoices endpointet dækker over faktura i E-Komplet. På endpointet kan man hente faktura som ligger i E-Komplet.",
        "Nedenstående kan man læse om hvilke værdier der kan hentes ud igennem API'et.",
      ],
      response: [
        {
          ID: 31,
          CustomerID: 10,
          Category: "Regningsarbejde",
          ProjectID: 18,
          EdiTransferStatus: 0,
          EdiPostParsingMessageID: null,
          DebtorFinancialAccountID: 19,
          ProjectIsClosed: true,
          InvoiceType: "Faktura",
          IsDraft: false,
          DebtorReference: "35353535",
          DebitorNote: null,
          DebtorName: "Jane Steffensen",
          DebtorCVR: null,
          _vatZone: "Domestic",
          VatZone: "Indland",
          AppendixNumber: 10024,
          RequisitionNumber: null,
          Date: "2013-12-02T23:00:00Z",
          DueDate: "2013-12-10T23:00:00Z",
          ProjectReference: "2010",
          Title: "nyt bl. bat. gæstetoil.",
          Price: 14838.54,
          RemainingAmount: 0.0,
          Status: "Betalt",
          DeliveryStatus: "Sendt til: johnny@e-komplet.dk",
          PriceWOVat: 11870.83,
          VatAmount: 2967.71,
          PaymentMethod: "Email",
          Department: null,
          Carrier: null,
          Purpose: null,
          EdiReceiver: null,
          PaymentTerms: "8 dage netto",
          ProjectResponsible: "system admin",
          IsOverdue: false,
          CreatedByUser: "system admin",
          CreatedDate: "2013-12-02T23:00:00Z",
          LastUpdatedByUser: "system admin",
          LastUpdatedDate: "2013-12-02T23:00:00Z",
          WorkAddress: "Toften 58",
          SubscriptionID: null,
          SubscriptionReference: null,
          CurrencyCode: "DKK",
          CurrencyRate: 100.0,
          ForeignAmount: 14838.54,
          ForeignRemainingAmount: 0.0,
          ForeignPriceWithoutVat: 11870.83,
          ForeignVatAmount: 2967.71,
          ProjectType: "MiniProject",
          ProjectGroup: "Alm. spjæld VVS",
          Actions: null,
          ShowFiles: true,
          DateRangeStartDate: "2013-12-02T23:00:00Z",
          DateRangeEndDate: "2013-12-02T23:00:00Z",
        },
      ],
      endpoints: [
        {
          verb: "GET",
          path: `/api/v3.0/${endPointName.toLowerCase()}`,
        },
        {
          verb: "GET",
          path: `/api/v3.0/${endPointName.toLowerCase()}/:id`,
        },
        {
          verb: "GET",
          path: `/api/v3.0/${endPointName.toLowerCase()}/:id/fitternote`,
        },
        {
          verb: "GET",
          path: `/api/v3.0/${endPointName.toLowerCase()}/pdf/:id`,
        },
        {
          verb: "POST",
          path: `/api/v3.0/${endPointName.toLowerCase()}/project`,
        }
      ],
      attributes: [
        {
          name: "CustomerID",
          desc: "Unique identifier of the customer that associates with the invoice.",
        },
        {
          name: "ProjectID",
          desc: "Unique identifier of the project that associates with the invoice.",
        },
        {
          name: "EdiPostParsingMessageID",
          desc: "",
        },
        {
          name: "DebtorFinancialAccountID",
          desc: "Unique identifier of the financial account of the debtor that is associated iwth the invoice.",
        },
      ],
      fileResponseTitle: `Generated PDF report file object`,
      fileResponseCodeTitle: `${endPointName.toLowerCase()}/:id/file - GENERATED PDF REPORT FILE RESPONSE`,
      fileResponse: [
        {
          FileData: "JVBERi0x...",
          SizeInBytes: 123456,
          MimeType: "application/pdf",
          InvoiceId: 123,
        },
      ],
      fileAttributes: [
        {
          name: "FileData",
          desc: "The file data as byte array encoded in base64.",
        },
        {
          name: "SizeInBytes",
          desc: "The size of the file in bytes.",
        },
        {
          name: "MimeType",
          desc: "The mime type of the file.",
        },
        {
          name: "InvoiceId",
          desc: "The invoice id of the invoice that the file is associated with.",
        },
      ],
      createInvoiceTitle: "Create Sales Invoice from Project",
      createInvoiceDesc: [
        "Dette endpoint svarer til at trykke 'Ny salgsfaktura', på en sag i E-Komplet.",
      ],
      createInvoiceRequestTitle: "CreateSalesInvoiceDTO",
      createInvoiceRequestCodeTitle: "POST /api/v3.0/invoices/project - CreateSalesInvoiceDTO",
      createInvoiceRequest:
      {
          "Reference": "123456",
      },
      createInvoiceRequestAttributes: [
        {
          name: "Reference",
          desc: "Sagsnummeret på den sag du ønsker at oprette en faktura på baggrund af.",
        },
      ],
      createInvoiceResponseTitle: `SalesInvoice Created from Project`,
      createInvoiceResponseCodeTitle: `POST /api/v3.0/invoices/project - RESPONSE`,
      createInvoiceResponse: {
        "data": {
            "invoiceId": 123,
            "customerId": 10,
            "projectId": 18,
            "categoryId": 5,
            "title": "Example Project Invoice",
            "isCustomer": true,
            "dueDate": "2025-11-18T00:00:00",
            "paymentTermId": 1,
            "workDescription": "",
            "appendix": 100,
            "financialAccountId": 19,
            "projectDepartmentId": 1,
            "isAdvanced": false,
            "responsibleAtCustomer": "",
            "fiNumber": "Preview",
            "isInvoiceNotification": false,
            "creatorId": "00000000-0000-0000-0000-000000000000",
            "isDraft": true,
            "paymentMethod": "Post",
            "deliveryStatus": "",
            "currencyRate": 100.000000,
            "currencyId": "DKK",
            "dimensionCarrierId": null,
            "dimensionDepartmentId": null,
            "dimensionPurposeId": null,
            "ediTransferStatus": null,
            "invoiceSumRemaining": 0.00,
            "ediReceiver": null,
            "fK_EdiPostParsingMessage_ID": null,
            "priceWithoutVat": 0.00,
            "vatAmount": 0.00,
            "totalCost": 0.00,
            "totalCostPercentage": 0,
            "projectDescriptionIncludeInOIOUBL": true,
            "workDescriptionIncludeInOIOUBL": true,
            "workNotesIncludeInOIOUBL": true,
            "requisitionNumber": null,
            "customerName": "Example Company A/S",
            "customerAddress": "Example Street 123",
            "customerZip": "1234",
            "customerAddress2": "Example District",
            "customerCity": "Example City",
            "customerReference": 12345678,
            "customerCVR": "11111111",
            "customerFax": null,
            "customerEAN": null,
            "customerHouseNumber": null,
            "customerCountry": "DK",
            "customerContactName": null,
            "customerContactPhone": null,
            "customerContactEmail": null,
            "createdByUserId": "00000000-0000-0000-0000-000000000000",
            "createdDate": "2025-11-10T10:30:42.207",
            "lastUpdatedByUserId": "00000000-0000-0000-0000-000000000000",
            "lastUpdatedDate": "2025-11-10T10:30:42.207",
            "postedByUserId": null,
            "postedDate": null,
            "orderDate": "2025-11-10T00:00:00",
            "additionalInfo": null,
            "projectDescription": null,
            "workNotes": "",
            "reportDocumentConfigurationName": "Standard Template",
            "reportDocumentConfigurationItemFilename": "C:\\Templates\\InvoiceReport.mrt",
            "reportDocumentConfigurationItemId": 1,
            "foreignPriceWithoutVat": 0.00,
            "foreignVatAmount": 0.00,
            "foreignTotalCost": 0.00,
            "associatedPersonId": null,
            "copySourceID": null,
            "customerEmail": null,
            "workInterval": null,
            "vatTypeId": null,
            "subscriptionID": null,
            "bsMandateNumber": null,
            "projectReference": null,
            "projectName": null,
            "dimensionCarrierName": null,
            "dimensionDepartmentName": null,
            "dimensionPurposeName": null,
            "currency": null,
            "paymentTerm": null,
            "note": null,
            "previouslyBilled": 0.0,
            "previouslyBilledPercentage": 0,
            "foreignPreviouslyBilled": 0.0,
            "worksheets": null,
            "invoiceTotal": 0.0,
            "foreignInvoiceTotal": 0.0,
            "associatedAddressId": null,
            "billingNote": null,
            "billingNoteLastUpdatedDate": null,
            "billingNoteLastUpdatedByID": null
        },
        "errorMessage": null,
        "validationErrors": [],
        "modelStateErrors": {},
        "hasErrors": false
    },
      createInvoiceAttributes: [
        {
          name: "invoiceId",
          desc: "Fakturaens unikke ID.",
          type: "integer"
        },
        {
          name: "customerId",
          desc: "Kundens unikke ID (Kan bruges til opslag på: /api/v3.0/debtors/:id).",
          type: "integer"
        },
        {
          name: "projectId",
          desc: "Den tilknyttede sags unikke ID.",
          type: "integer"
        },
        {
          name: "categoryId",
          desc: "Sagsgruppen unikke ID.",
          type: "integer"
        },
        {
          name: "title",
          desc: "Overskrift på faktura.",
          type: "string"
        },
        {
          name: "dueDate",
          desc: "Fakturadato.",
          type: "datetime"
        },
        {
          name: "paymentTermId",
          desc: "Betalingsbetingelses unikke ID.",
          type: "integer"
        },
        {
          name: "workDescription",
          desc: "Arbejde udført.",
          type: "string"
        },
        {
          name: "appendix",
          desc: "Bilag",
          type: "integer"
        },
        {
          name: "financialAccountId",
          desc: "Finanskontos unikke ID (/api/v4.0/financialAccounts).",
          type: "integer"
        },
        {
          name: "isDraft",
          desc: "Angivelse af om faktura er en kladde eller ej.",
          type: "boolean"
        },
        {
          name: "paymentMethod",
          desc: "Faktureringsmetode.",
          type: "string"
        },
        {
          name: "deliveryStatus",
          desc: "Status på levering.",
          type: "string"
        },
        {
          name: "currencyId",
          desc: "Valutaenhed.",
          type: "string"
        },
        {
          name: "currencyRate",
          desc: "Valutakurs.",
          type: "number"
        },
        {
          name: "priceWithoutVat",
          desc: "Pris u. moms.",
          type: "number"
        },
        {
          name: "vatAmount",
          desc: "Moms.",
          type: "number"
        },
        {
          name: "totalCost",
          desc: "Totalbeløb.",
          type: "number"
        },
        {
          name: "customerName",
          desc: "Navn på kunde/debitor.",
          type: "string"
        },
        {
          name: "customerAddress",
          desc: "Kunde/debitors adresse",
          type: "string"
        },
        {
          name: "customerZip",
          desc: "Kunde/debitors postnummer.",
          type: "string"
        },
        {
          name: "customerCity",
          desc: "Kunde/debitors by.",
          type: "string"
        },
        {
          name: "customerCVR",
          desc: "Kunde/debitors cvrnummer.",
          type: "string"
        },
        {
          name: "customerCountry",
          desc: "Kunde/debitors land.",
          type: "string"
        },
        {
          name: "createdByUserId",
          desc: "GUID på den bruger faktura er oprettet af.",
          type: "GUID"
        },
        {
          name: "createdDate",
          desc: "Dato for oprettelse.",
          type: "dateTime"
        },
        {
          name: "lastUpdatedByUserId",
          desc: "GUID på den bruger som sidst har opdateret faktura.",
          type: "GUID"
        },
        {
          name: "lastUpdatedDate",
          desc: "Dato for sidste opdatering af faktura.",
          type: "dateTime"
        }
      ],
    };
  },
};
</script>
<style scoped>
</style>
